import React from 'react';
import Eyebrow from '../motion/Eyebrow';
import KineticHeadline from '../motion/KineticHeadline';
import Reveal from '../motion/Reveal';
import SectionLight from '../motion/SectionLight';

const ROWS = [
  {
    k: 'Wagers',
    pnp: 'None. We never accept bets or entry fees.',
    book: 'Real-money wagers are taken on the platform.',
  },
  {
    k: 'Payments',
    pnp: 'None processed. Pool organizers handle any optional buy-ins directly.',
    book: 'Deposits and withdrawals run through the sportsbook.',
  },
  {
    k: 'Purpose',
    pnp: 'Private group entertainment and friendly competition.',
    book: 'Real-money gambling, subject to local laws.',
  },
  {
    k: 'Compliance',
    pnp: 'Private groups only. Users are responsible for their local laws.',
    book: 'Licensed and regulated in eligible jurisdictions.',
  },
];

const Yes = () => (
  <span className="pnp-vs-ico is-yes" aria-hidden="true">
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"><polyline points="20 6 9 17 4 12" /></svg>
  </span>
);
const Dot = () => (
  <span className="pnp-vs-ico is-no" aria-hidden="true">
    <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round"><line x1="6" y1="12" x2="18" y2="12" /></svg>
  </span>
);

/** PNP vs SPORTSBOOKS: the private-group disclaimer, as two glass corners instead of a boxed table. */
export default function DisclaimerSection() {
  return (
    <section className="pnp-section" aria-labelledby="pnp-vs-title">
      <SectionLight bleed="60px">
        <div className="pnp-glow pnp-glow-center" style={{ top: '10%', opacity: 0.5 }} />
      </SectionLight>
      <div className="pnp-wrap">
        <div className="pnp-head pnp-center">
          <Eyebrow>Private group disclaimer</Eyebrow>
          <div id="pnp-vs-title"><KineticHeadline text={'Bragging rights.\n*Not* a sportsbook.'} /></div>
          <Reveal delay={200}>
            <p className="pnp-lead">
              Pick &apos;N Pray is for private group entertainment only. We don&apos;t take wagers, process payments or
              guarantee prizes.
            </p>
          </Reveal>
        </div>

        <div className="pnp-vs-grid">
          <Reveal>
            <div className="pnp-glass pnp-glass-red pnp-vs-card">
              <div className="pnp-eyebrow"><span className="pnp-eyebrow-claw" aria-hidden="true"><i /><i /><i /></span><span>Red corner</span></div>
              <h3 className="pnp-display pnp-h3">Pick &apos;N Pray</h3>
              <ul className="pnp-vs-list">
                {ROWS.map((r) => (
                  <li key={r.k}><Yes /><span><span className="pnp-vs-k">{r.k}</span><span className="pnp-vs-v">{r.pnp}</span></span></li>
                ))}
              </ul>
            </div>
          </Reveal>
          <div className="pnp-vs-badge" aria-hidden="true"><span className="pnp-vs">VS</span></div>
          <Reveal delay={140}>
            <div className="pnp-glass pnp-vs-card is-muted">
              <div className="pnp-eyebrow" style={{ color: 'var(--mist)' }}><span className="pnp-eyebrow-claw" aria-hidden="true"><i /><i /><i /></span><span>Blue corner</span></div>
              <h3 className="pnp-display pnp-h3" style={{ color: 'rgba(255,255,255,0.7)' }}>Sportsbooks</h3>
              <ul className="pnp-vs-list">
                {ROWS.map((r) => (
                  <li key={r.k}><Dot /><span><span className="pnp-vs-k">{r.k}</span><span className="pnp-vs-v">{r.book}</span></span></li>
                ))}
              </ul>
            </div>
          </Reveal>
        </div>
        <Reveal>
          <p className="pnp-fineprint">
            Not affiliated with, endorsed or sponsored by the UFC. No real-money wagering, payout processing or betting
            services are provided.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
